import {
  getPartStatus,
}from 'pu-utils/PartsUtilities';

// This function work whith the state
export const calculateTotals = (totals, offers, quantities) => {
  quantities.map((quantity) => {
    totals[quantity] = 0;
  });

  Object.entries(offers).forEach(([key, offer]) => {
    const status = offer.status;
    const qty_per_board = offer.qty_per_board || 1;
    var options = offer.vendor_options;

    quantities.map((quantity) => {
      if (status[quantity] == "substitute"){
        var substitute = offer.substitute;
        if (substitute !== undefined){
          var subs_options = substitute.vendor_options;
          if (offer.purchase_status[quantity] == "buy"){
            subs_options.forEach(function (option, index) {
              if (option.check !== undefined && option.check){
                var price = option.unit_price * option.qty_selected;
                totals[quantity] = totals[quantity] + price;
              }
            });
          }
        }
      }else{
        if (status[quantity] == "other"){
          options = offer.other.vendor_options;
          options[quantity].forEach(function (option, index) {
            totals[quantity] = totals[quantity] + option.price;
          });
        }
        if (status[quantity] == "enough-stock"
            && (quantity in offer.purchase_status)
            && offer.purchase_status[quantity] == "buy"){
            if (options !== undefined){
            options[quantity].forEach(function (option, index) {
              totals[quantity] = totals[quantity] + option.price;
            });
          }
        }
      }
    });
  });
  return totals;
}

export const addPossibleSubstitute = (possibleSustitutes, substitute, option_id) =>{
  if (possibleSustitutes.length == 0){
    let substitute_new = {...substitute, options_selected:[option_id]}
    possibleSustitutes.push(substitute)
  }
}

export const removePossibleSubstitute = (possibleSustitutes, substitute, option_id) =>{

}



// This function work whith the state
export const updatePartPurchaseStatus = (offer, quantities, value, selectedQuantity) => {
  quantities.forEach((quantity) => {
    if (offer.purchase_status[quantity] === undefined
        || quantity == selectedQuantity ){
      offer.purchase_status[quantity] = value;
    }
  });
}

export const assignSubstitutePart = (offer, quantities, substitute, selectedQuantity) => {
  offer.substitute = substitute;
  
  quantities.forEach((quantity) => {
    const qty_needed = offer.qty_per_board * quantity
    offer.status[quantity] = "substitute";
    offer.chosen_part_id = substitute.id;
    offer.purchase_status[quantity] = 'buy';
    // if (offer.purchase_status[quantity] === undefined
    //     && substitute.stock[quantity] >= qty_needed ){
    //   offer.purchase_status[quantity] = 'buy';
    // }
  });
  // ADD ONLY SELECTED OPTION 
  // var vendor_options = substitute.vendor_options
  // var new_vendor_options = []
  // vendor_options.forEach((option) => {
  //   if (substitute.options_selected.includes(option.id)){
  //     new_vendor_options.push(option)
  //   }
  // });

  // var new_substitute = {...substitute, vendor_options: new_vendor_options}

  // offer.substitute = new_substitute;
  // quantities.forEach((quantity) => {
  //   offer.status[quantity] = "substitute";
  //   // offer.chosen_part_id = substitute_id;
  //   if (offer.purchase_status[quantity] === undefined
  //       || quantity == selectedQuantity ){
  //     offer.purchase_status[quantity] = 'buy';
  //   }
  // });
}

export const assignSimilarPart = (offer, quantities, substitute, selectedQuantity) => {
  offer.other = substitute;
  
  quantities.forEach((quantity) => {
    const qty_needed = offer.qty_per_board * quantity
    offer.status[quantity] = "other";
    offer.chosen_part_id = substitute.id;
    offer.purchase_status[quantity] = 'buy';
    // if (offer.purchase_status[quantity] === undefined
    //     && substitute.stock[quantity] >= qty_needed ){
    //   offer.purchase_status[quantity] = 'buy';
    // }
  });
}

export const checkPurchaseStatus = (offers, selectedQuantity) => {
  var errors = {}
  Object.entries(offers).forEach(([key, offer]) => {
    if (offer.purchase_status[selectedQuantity] === undefined
        || offer.purchase_status[selectedQuantity] == ""){
      errors = {"purchase_status" : "Please, select an action for each part of the boom."}
    }
  });
  return errors;
}

export const generateBomReport = (report, offers, vendors, quantities, selectedQuantity) => {
  var assembly_report = {};
  var status_report = {};
  var vendor_report = {};
  var selected_quantity = selectedQuantity;

  if (selected_quantity === null){
    selected_quantity = quantities[0]; 
  }
  quantities.map((quantity) => {
    status_report[quantity] = {};
    status_report[quantity]['enough_stock'] = 0;
    status_report[quantity]['no_enough_stock'] = 0;
    status_report[quantity]['no_stock'] = 0;
    status_report[quantity]['no_perfect_match'] = 0;
    status_report[quantity]['not_found'] = 0;
    vendor_report[quantity] = {};
    vendors.map((vendor) =>{
      vendor_report[quantity][vendor] = 0;
    })
  });

  assembly_report['bom_line_items'] = Object.keys(offers).length;
  assembly_report['smt'] = 0;
  assembly_report['qfn'] = 0;
  assembly_report['bga'] = 0;
  assembly_report['thru_hole'] = 0;
  assembly_report['unknown_mounting_type'] = 0;

  Object.entries(offers).forEach(([key, offer]) => {
    var status = getPartStatus(offer.status, selected_quantity)

    var mounting_type = offer.mounting_type;
    var mounting_type_entered = offer.mounting_type_entered;

    if (status == "substitute"){
      mounting_type = offer.substitute.mounting_type;
      mounting_type_entered = "";
    }
    if (status == "other"){
      mounting_type = offer.other.mounting_type;
      mounting_type_entered = "";
    }

    if((mounting_type == "" || mounting_type === undefined) &&
       (mounting_type_entered == "" || mounting_type_entered === undefined)) {
      assembly_report['unknown_mounting_type']++;
    }

    if(mounting_type == "SMT" || mounting_type_entered == "SMT"){ 
      assembly_report['smt'] = assembly_report['smt'] + offer.qty_per_board;
    }
    if(mounting_type == "QFN" || mounting_type_entered == "QFN"){
      assembly_report['qfn'] = assembly_report['qfn'] + offer.qty_per_board; 
    }
    if(mounting_type == "BGA" || mounting_type_entered == "BGA"){ 
      assembly_report['bga'] = assembly_report['bga'] + offer.qty_per_board; 
    }
    if(mounting_type == "THT" || mounting_type_entered == "THT"){ 
      assembly_report['thru_hole'] = assembly_report['thru_hole'] + offer.qty_per_board; 
    }

    quantities.map((quantity) => {
      var status = offer.status[quantity];
      var purchase_status = offer.purchase_status[quantity];
      var vendor_options = offer.vendor_options;

      if (status == "substitute"){
        vendor_options = offer.substitute.vendor_options;
      }
      if (status == "other"){
        vendor_options = offer.other.vendor_options;
      }

      switch (status){
        case "enough-stock":
          status_report[quantity]['enough_stock'] ++;
          break;
        case "no-enough-stock":
          status_report[quantity]['no_enough_stock'] ++;
          break;
        case "no-stock":
        case "no-perfect-match":
        case "not-found":
          status_report[quantity]['no_stock'] ++;
        case "no-perfect-match":
          status_report[quantity]['no_perfect_match'] ++;
          break;
        case "not-found":
          status_report[quantity]['not_found'] ++;
          break;
        case "substitute":
        case "other":
          report['status'][quantity]['substitute'] ++;
          break;
        default:
          break;
      }

      if (status== "substitute"){
        // var vos = vendor_options[quantity];
        // vos.forEach(function (option, index) {
        //   if (option.vendor in report["vendor"][quantity] && option.check !== undefined && option.check){
        //     report["vendor"][quantity][option.vendor] ++;
        //   }
        // });
      }else{
        if (vendor_options !== undefined 
            && Object.keys(vendor_options).length !== 0 
            && (quantity in vendor_options)){
              var vos = vendor_options[quantity];
              vos.forEach(function (option, index) {
                if (option.vendor in vendor_report[quantity]){
                  vendor_report[quantity][option.vendor] ++;
                }
              });
        }
      }
    });
    
  });
  report["status"] = status_report;
  report["vendor"] = vendor_report;
  report["assembly_parameters"] = assembly_report;

  return report;
}

export const getReport = (quote, selectedQuantity) => {
  var report = {};
  var errors = {}
  var offers = quote.offers;
  var vendors = quote.vendors;
  var quantities = quote.quantities;

  report['status']= {};
  report['vendor']= {};

  quantities.map((quantity) => {
    report['status'][quantity] = {};
    report['status'][quantity]['buy_parts'] = 0;
    report['status'][quantity]['no_install_parts'] = 0;
    report['status'][quantity]['will_provide_parts'] = 0;
    report['status'][quantity]['enough_stock'] = 0;
    report['status'][quantity]['no_enough_stock'] = 0;
    report['status'][quantity]['no_stock'] = 0;
    report['status'][quantity]['no_perfect_match'] = 0;
    report['status'][quantity]['not_found'] = 0;
    report['status'][quantity]['substitute'] = 0;
    report['status'][quantity]['no_status'] = 0;
    report["vendor"][quantity] = {};
    vendors.map((vendor) =>{
      report["vendor"][quantity][vendor] = 0;
    })
  });


  report['assembly_parameters'] = {};
  report['assembly_parameters']['bom_line_items'] = Object.keys(offers).length;
  report['assembly_parameters']['smt'] = 0;
  report['assembly_parameters']['qfn'] = 0;
  report['assembly_parameters']['bga'] = 0;
  report['assembly_parameters']['thru_hole'] = 0;
  report['assembly_parameters']['unknown_mounting_type'] = 0;


  Object.entries(offers).forEach(([key, offer]) => {
    var status = getPartStatus(offer.status, selectedQuantity)

    var mounting_type = offer.mounting_type;
    var mounting_type_entered = offer.mounting_type_entered;

    if (status == "substitute"){
      mounting_type = offer.substitute.mounting_type;
      mounting_type_entered = "";
    }
    if (status == "other"){
      mounting_type = offer.other.mounting_type;
      mounting_type_entered = "";
    }

    if((mounting_type == "" || mounting_type === undefined) &&
       (mounting_type_entered == "" || mounting_type_entered === undefined)) {
      report['assembly_parameters']['unknown_mounting_type']++;
    }
    
    if (status != "no-install"){
      if(mounting_type == "SMT" || mounting_type_entered == "SMT"){ report['assembly_parameters']['smt'] = report['assembly_parameters']['smt'] + offer.qty_per_board; }
      if(mounting_type == "QFN" || mounting_type_entered == "QFN"){ report['assembly_parameters']['qfn'] = report['assembly_parameters']['qfn'] + offer.qty_per_board; }
      if(mounting_type == "BGA" || mounting_type_entered == "BGA"){ report['assembly_parameters']['bga'] = report['assembly_parameters']['bga'] + offer.qty_per_board; }
      if(mounting_type == "THT" || mounting_type_entered == "THT"){ report['assembly_parameters']['thru_hole'] = report['assembly_parameters']['thru_hole'] + offer.qty_per_board; }
    }

    // Check de actually status from
    // Part Status for each quantity
    quantities.map((quantity) => {
      var status = offer.status[quantity];
      var purchase_status = offer.purchase_status[quantity];
      var vendor_options = offer.vendor_options;

      if (status == "substitute"){
        vendor_options = offer.substitute.vendor_options;
      }

      if (status == "other"){
        vendor_options = offer.other.vendor_options;
      }

      switch (status){
        case "enough-stock":
            report['status'][quantity]['enough_stock'] ++;
          break;
        case "no-enough-stock":
          report['status'][quantity]['no_enough_stock'] ++;
          break;
        case "no-stock":
          report['status'][quantity]['no_stock'] ++;
          break;
        case "no-perfect-match":
        case "not-found":
          report['status'][quantity]['not_found'] ++;
          break;
        case "substitute":
        case "other":
          report['status'][quantity]['substitute'] ++;
          break;
        default:
          report['status'][quantity]['no-status'] ++;
      }

      switch (purchase_status){
        case "buy":
          report['status'][quantity]['buy_parts'] ++;
          break;
        case "no-install":
          report['status'][quantity]['no_install_parts'] ++;
          break;
        case "i-will-provide":
          report['status'][quantity]['will_provide_parts'] ++;
          break;
        default:
          break;
      }
      
      if (status== "substitute"){
        var vos = vendor_options[quantity];
        // vos.forEach(function (option, index) {
        //   if (option.vendor in report["vendor"][quantity] && option.check !== undefined && option.check){
        //     report["vendor"][quantity][option.vendor] ++;
        //   }
        // });
      }else{
        if (vendor_options !== undefined 
            && Object.keys(vendor_options).length !== 0 
            && (quantity in vendor_options)){
              var vos = vendor_options[quantity];
              vos.forEach(function (option, index) {
                if (option.vendor in report["vendor"][quantity]){
                  report["vendor"][quantity][option.vendor] ++;
                }
              });
        }
      }
    });

  });

  return {report, errors};
}
